import * as R from 'ramda'

export const mapInternalStateToPayload = state => {
  const { competencies, language, name, department } = state

  return {
    language: R.view(R.lensProp('value'), language ?? {}),
    skills: R.reduce(
      (acc, { name, ...rest }) => ({ ...acc, [name]: R.prop(name)(rest) }),
      {},
      competencies,
    ),
    title: name,
    department: department.value,
  }
}
